module.exports = __webpack_public_path__ + "img/loading.5f9d0ffe.gif";